import React from "react";
import MainPagePresenter from "./MainPagePresenter";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route } from "react-router-dom";
import OffCanvas from "../../components/OffCanvas";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, Progress, LogoHolder } from "../../nq-component";
import AccountPage from "../account/AccountPage";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
import ProductFormPage from "../product-form/ProductFormPage";
import ProductListPage from "../product-list/ProductListPage";
import SellerFormPage from "../seller-form/SellerFormPage";
import { findObjectUseCase } from "../../usecases/object";
import SellerApprovalPage from "../seller-approval/SellerApprovalPage";
import ClientListPage from "../client/list/ClientListPage";
import ClientFormPage from "../client/form/ClientFormPage";
import ClientInfoPage from "../client/info/ClientInfoPage";
import Menu from "../../components/Menu";
import InquiriesListPage from "../inquiries/list/InquiriesListPage";
import InquiriesAddFormPage from "../inquiries/form/add/InquiriesAddFormPage";
import InquiriesEditFormPage from "../inquiries/form/edit/InquiriesEditFormPage";
import InquiriesViewPage from "../inquiries/view/InquiriesViewPage";
import InquiriesInfoPage from "../inquiries/info/InquiriesInfoPage";
import EmailBlastListPage from "../email-blast/list/EmailBlastListPage";
import EmailBlastFormPage from "../email-blast/form/EmailBlastFormPage";
import EmailBlastViewPage from "../email-blast/view/EmailBlastViewPage";
import FollowUpListPage from "../follow-up/list/FollowUpListPage";
import FollowUpFormPage from "../follow-up/form/FollowUpFormPage";
import FollowUpViewPage from "../follow-up/view/FollowUpViewPage";
import DashboardPage from "../dashboard/DashboardPage";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase(),
      findObjectUseCase(),
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  render() {
    const user = this.getCurrentUser();

    if (this.state.loading) {
      return (
        <div className="min-vh-100 d-flex justify-content-center align-items-center ">
          <Progress />
        </div>
      );
    }
    const document = this.getGlobalState("sellerDocument");
    const isApproved = document === undefined || document.status !== "Approved";

    const menus = [
      {
        name: "Dashboard",
        route: "/dashboard",
        icon: "bi bi-layout-text-sidebar-reverse text-primary",
        //"disabled": isApproved
      },
      {
        name: "Property List",
        route: "/collection/properties",
        icon: "bi bi-house-down text-primary",
        //"disabled": isApproved
      },
      {
        name: "Inquiries",
        route: "/inquiries",
        icon: "bi bi-question-square text-primary",
        //"disabled": isApproved
      },
      {
        name: "Clients",
        route: "/client",
        icon: "bi bi-person-square text-primary",
        //"disabled": isApproved
      },
      {
        name: "Email Blast",
        route: "/email-blast",
        icon: "bi bi-envelope text-primary",
        //"disabled": isApproved
      },
    ];
    return (
      <>
        {isApproved ? (
          <Routes>
            <Route path={"/seller/form"} element={<SellerFormPage />} />
            <Route path={"/seller/approval"} element={<SellerApprovalPage />} />
          </Routes>
        ) : (
          <Layout>
            <Layout.Context.Consumer>
              {(value) => (
                <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
                  <div className="offcanvas-body bg-white">
                    <nav className="navbar-dark">
                      <div className="mt-4 text-center">
                        {/* <LogoHolder
                                            className='bg-primary'
                                            textClassName='text-white'
                                            logo={user.avatar}
                                            name={user.username}
                                        /> */}
                        <img
                          src="/logo2.png"
                          style={{ height: "80px", width: "80px" }}
                        ></img>
                        <h2 className="text-black mt-3 text-capitalize fw-bold">
                          {user.name || user.first_name}
                        </h2>
                        <p className="text-black">
                          {user.name || user.username}
                        </p>
                      </div>
                      <button
                        onClick={() => window.location.href = "https://ebowr.com"}
                        className="btn btn-dark w-100 mb-2 d-flex align-items-center justify-content-center gap-2"
                      >
                        <i className="bi bi-house-door"></i>
                        Buyer Mode
                      </button>
                      <hr className="border border-dark border-1 opacity-50" />
                      <Menu
                        onClickItem={this.onClickMenu.bind(this)}
                        menus={menus}
                      />
                    </nav>
                  </div>
                  <hr className="border border-white my-0  border opacity-25" />
                  <div className="p-3 bg-white">
                    <div className="border border-dark rounded p-2">
                      <button
                        className="nav-link text-primary btn btn-link"
                        onClick={this.onClickSignOut.bind(this)}
                      >
                        <i className="bi bi-power"></i>
                        <span className="ms-2 text-black fw-bold small">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>
                </OffCanvas>
              )}
            </Layout.Context.Consumer>
            <main className="vh-100 d-flex flex-column">
              <Routes>
                <Route exact path={"/"} element={<DashboardPage />} />
                <Route exact path={"/dashboard"} element={<DashboardPage />} />
                <Route
                  exact
                  path={"/collection/:name"}
                  element={<CollectionListPage />}
                />
                <Route
                  path={"/collection/roles/form"}
                  element={<RoleFormPage />}
                />
                <Route
                  path={"/collection/roles/form/:id"}
                  element={<RoleFormPage />}
                />
                <Route
                  path={"/collection/:name/form/"}
                  element={<CollectionFormPage />}
                />
                <Route
                  path={"/collection/:name/form/:id"}
                  element={<CollectionFormPage />}
                />
                <Route path={"/:name/form/"} element={<ClientFormPage />} />
                <Route path={"/:name/form/:id"} element={<ClientFormPage />} />
                <Route path={"/:name/view/:id"} element={<ClientInfoPage />} />
                <Route
                  path={"/:name/quotation/form"}
                  element={<InquiriesAddFormPage />}
                />
                <Route
                  path={"/:name/quotation/form/:id"}
                  element={<InquiriesEditFormPage />}
                />
                <Route
                  path={"/:name/quotation/view/:id"}
                  element={<InquiriesViewPage />}
                />
                <Route
                  path={"/:name/quotation/info/:id"}
                  element={<InquiriesInfoPage />}
                />
                <Route
                  path={"/inquiries/quotation/follow-up/:id"}
                  element={<FollowUpListPage />}
                />
                <Route
                  path={"/inquiries/quotation/follow-up/:inquiryId/new"}
                  element={<FollowUpFormPage />}
                />
                <Route
                  path={"/inquiries/quotation/follow-up/:inquiryId/view/:id"}
                  element={<FollowUpViewPage />}
                />
                <Route path={"/:name/new"} element={<EmailBlastFormPage />} />
                <Route
                  path={"/:name/view-blast/:id"}
                  element={<EmailBlastViewPage />}
                />
                <Route path={"/seller/form"} element={<SellerFormPage />} />
                <Route
                  path={"/seller/approval"}
                  element={<SellerApprovalPage />}
                />
                <Route path={"/inquiries"} element={<InquiriesListPage />} />
                <Route path={"/email-blast"} element={<EmailBlastListPage />} />
                <Route path={"/client"} element={<ClientListPage />} />
                <Route path={"/product/form"} element={<ProductFormPage />} />
                <Route path={"/product/list"} element={<ProductListPage />} />
                <Route
                  path={"/product/form/:id"}
                  element={<ProductFormPage />}
                />
                <Route path={"/account"} element={<AccountPage />} />
                <Route element={<NotFoundPage />} />
              </Routes>
            </main>
          </Layout>
        )}
      </>
    );
  }
}

export default withRouter(MainPage);
